import { render, staticRenderFns } from "./AdList.vue?vue&type=template&id=15808257&"
import script from "./AdList.vue?vue&type=script&lang=js&"
export * from "./AdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports